import { getSapC4cBaseUrl } from '../../utils/config';
import { logger } from '../../utils/logger';
import { AuthBootstrapContext } from './types';
import { signalWidgetReady } from './cti-context';

export function getCtiSapHost(): string | null {
  const sapHost = getSapC4cBaseUrl()?.trim();
  return sapHost || null;
}

export function isCtiEmbed(): boolean {
  return window.parent !== window && Boolean(getCtiSapHost());
}

export function getAuthContextMissingMessage(): string {
  if (window.parent !== window) {
    const sapHost = getCtiSapHost();
    if (!sapHost) {
      return (
        'SAP CTI widget is embedded but features.sapC4cBaseUrl is not configured in overrides.js. ' +
        'Set it to your SAP tenant URL (e.g. https://my1002272.us1.test.crm.cloud.sap).'
      );
    }

    return 'Unable to start session. Sign in to NiCE CXone to continue.';
  }

  return 'This widget must be opened from SAP Agent Desktop (CTI embed).';
}

export async function resolveAuthBootstrapContext(): Promise<AuthBootstrapContext | null> {
  signalWidgetReady();

  const sapHost = getCtiSapHost();
  if (!isCtiEmbed() || !sapHost) {
    logger.debug('[SAP CTI] CTI embed context not available', {
      inIframe: window.parent !== window,
      sapHost: sapHost ?? null,
    });
    return null;
  }

  logger.debug('[SAP CTI] Using CTI embed with configured SAP host:', sapHost);
  return { sapHost };
}
